/**
 * vhtml-market (qidian-vhtml-template / rhino-components) 语言桥接
 *
 * 企点业务项目使用 vhtml-market 的真实方式是 CDN runtime：
 *   - 全量：<script src=".../rhino-component_2.0.0/index.js">
 *   - 单组件：window._rhinoComponents.marketRequire(name, version)
 *
 * vhtml-market 目前不是业务 npm 依赖，也不应由业务项目 import vhtml-market/src/locale/*。
 * 组件库语言包属于 vhtml-market 自身资产，业务侧只负责同步当前语言名。
 *
 * 当前桥接职责：
 *   1. 写 window.lang，兼容 vhtml-market 既有 marketRequire 判断；
 *   2. 如果未来 vhtml-market 暴露 window._rhinoComponents.setLocale(locale)，则调用它；
 *   3. 当前未暴露 setLocale 时，只给 warning，不要求业务维护语言包。
 *
 * 已知限制：
 *   - 当前 vhtml-market 主干 en-US.js 仍是中文占位；
 *   - marketRequire 单组件场景是否能切语言，取决于 vhtml-market 自身是否完成 locale runtime 改造；
 *   - 本桥接不提供业务侧语言包注入方案，避免职责倒挂。
 */

let warnedMissingRuntime = false;
let warnedMissingSetLocale = false;

/**
 * 将指定 qidianLocale 应用到 vhtml-market。
 *
 * @param {string} qidianLocale
 */
export function applyVhtmlMarketLocale(qidianLocale) {
    if (typeof window === 'undefined') return;

    const normalized = qidianLocale === 'en-US' ? 'en-US' : 'zh-CN';

    // vhtml-market 既有 marketRequire 代码会读取 window.lang。
    window.lang = normalized;

    const rhino = window._rhinoComponents;
    if (!rhino) {
        if (!warnedMissingRuntime && normalized === 'en-US' && typeof console !== 'undefined') {
            warnedMissingRuntime = true;
            console.warn('[i18n] window._rhinoComponents is not available; skip vhtml-market locale bridge.');
        }
        return;
    }

    // vhtml-market 自治改造后的理想 API：业务只传语言名，不传语言包。
    if (typeof rhino.setLocale === 'function') {
        rhino.setLocale(normalized);
        return;
    }

    if (!warnedMissingSetLocale && normalized === 'en-US' && typeof console !== 'undefined') {
        warnedMissingSetLocale = true;
        console.warn('[i18n] vhtml-market setLocale is not available; market components may remain zh-CN.');
    }
}
